import { JsonMap } from '../types';

export function deepFreeze(o: any) {
  Object.freeze(o);

  Object.getOwnPropertyNames(o).forEach(function(prop) {
    if (
      // eslint-disable-next-line no-prototype-builtins
      o.hasOwnProperty(prop) &&
      o[prop] !== null &&
      (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
      !Object.isFrozen(o[prop])
    ) {
      deepFreeze(o[prop]);
    }
  });

  return o;
}

export type BulkPayload<T extends JsonMap, IdFieldT extends keyof T = keyof T> = {
  create: Omit<T, IdFieldT>[];
  update: T[];
  delete: Array<T[IdFieldT]>;
};

export function createBulkFromArrays<T extends JsonMap, IdFieldT extends keyof T = keyof T>(
  newArr: (T |  Omit<T, IdFieldT> & Record<IdFieldT, undefined>)[],
  oldArr: T[],
  idField: IdFieldT
): BulkPayload<T, IdFieldT> {
  return {
    create: newArr.filter(item => !item[idField]),
    update: newArr.filter(item => !!item[idField]) as T[],
    delete: oldArr
      .filter(item => !newArr.find(newitem => item[idField] === newitem[idField]))
      .map(item => item[idField]),
  };
}

export const isEmptyBulkPayload = <T extends JsonMap, IdFieldT extends keyof T = keyof T>({
  create, update, delete: deleteList
}: BulkPayload<T, IdFieldT>) => {
  return !create.length && !update.length && !deleteList.length;
};
